export default "__VITE_ASSET__1b41ffea__"